import React from 'react'
import { Grid } from '@material-ui/core'
import moment from 'moment'
import SelectInput from 'components/common/SelectInput'
import LabeledInputContainer from 'components/common/inputs/LabeledInputContainer'
import SetNextScan from 'components/Patients/SetNextScan'
import FrequencyPicker from 'components/common/inputs/FrequencyPicker'
import AlignersSets from 'components/Patients/PatientCard/AlignersSets'
import { ALIGNERS_TREATMENT_TYPE, OTHER_TREATMENT_TYPE } from 'consts/treatmentConsts'
import DoubleScanPicker from 'components/Patients/PatientCard/DoubleScanPicker'
import { getStatusTypeFromKey, shouldOfferDoubleScanChoice } from 'utils/statusUtils'
import { useTranslation } from 'react-i18next'

const TreatmentSection = ({
  values,
  formErrors,
  treatmentStatusOptions,
  scanFrequencyDefaults,
  scanFrequencyOptions,
  periodTypeOptions
}) => {
  const { t } = useTranslation()

  // Same shared predicate as the parent; only the anchor differs. "Other" renders the
  // picker next to Treatment Type up there, so this branch takes everything else -- which
  // in practice means Retention for a non-Other type.
  const isRetentionScanTypeVisible =
    values.treatmentType !== OTHER_TREATMENT_TYPE &&
    shouldOfferDoubleScanChoice({
      treatmentType: values.treatmentType,
      statusType: getStatusTypeFromKey(values.treatmentStatus)
    })

  return (
    <>
      <Grid item xs={6}>
        <SetNextScan
          title={t('dialogs.invitePatient.firstScanDate')}
          date={values.firstScanDate.toDate()}
          onSet={newDate => values.setFirstScanDate(newDate ? moment(newDate) : null)}
          tooltip={t('dialogs.invitePatient.firstScanDateTooltip')}
        />
      </Grid>
      {values.treatmentType === ALIGNERS_TREATMENT_TYPE && (
        <Grid item xs={12}>
          <AlignersSets
            alignersSets={values.totalAlignersSets}
            setAlignersSets={values.setTotalAlignersSets}
            errorMessage={formErrors?.totalAlignersSets}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <SelectInput
          label={t('dialogs.invitePatient.treatmentStatusLabel')}
          options={treatmentStatusOptions}
          value={values.treatmentStatus}
          onChange={({ value }) => {
            values.setTreatmentStatus(value)
          }}
          style={{ bright: true, thick: true }}
          selectStyle={{ fontWeight: 500, paddingLeft: 0 }}
          keepErrorContainerWhenInactive={false}
          errorMessage={formErrors?.treatmentStatus}
          tooltip={t('dialogs.invitePatient.treatmentStatusTooltip')}
        />
      </Grid>
      {isRetentionScanTypeVisible && (
        <Grid item xs={12}>
          <LabeledInputContainer title={t('statuses.updateStatusModal.scanTypeSubtitle')}>
            <DoubleScanPicker isDoubleScan={values.isDoubleScan} onSet={values.setIsDoubleScan} />
          </LabeledInputContainer>
        </Grid>
      )}
      <Grid item xs={12}>
        <LabeledInputContainer
          title={t('dialogs.invitePatient.scanFrequency')}
          tooltip={t('tooltips.cycleInterval', { periodType: 'day' })}
        >
          <FrequencyPicker
            value={values.cycleInterval}
            setValue={values.setCycleInterval}
            periodType={values.cycleIntervalPeriodType}
            defaultPeriodType={scanFrequencyDefaults?.periodType}
            setPeriodType={values.setCycleIntervalPeriodType}
            options={scanFrequencyOptions}
            periodTypeOptions={periodTypeOptions}
          />
        </LabeledInputContainer>
      </Grid>
    </>
  )
}

export default TreatmentSection
